import React from 'react';
// Remove imports for external User type
// import { User } from '../../types/user';

// Define the specific shape of data needed by *this* component
interface ProfessionalDetailsUserData {
    name: string;
    profession?: string;
    company?: string;
    experience?: string;
    city?: string;
    country?: string;
    email?: string; // Email is optional here
}

interface ProfessionalDetailsProps {
    user: ProfessionalDetailsUserData; // Use the local interface
}

const ProfessionalDetails: React.FC<ProfessionalDetailsProps> = ({ user }) => {
  // Construct location name if needed
  const locationName = user.city 
      ? `${user.city}${user.country ? `, ${user.country}` : ''}` 
      : undefined;
  
  return (
    <div className="card border-0 shadow-sm mb-4">
        <div className="card-header bg-white py-3">
            <h5 className="mb-0 fw-bold">Professional Details</h5>
        </div>
        <div className="card-body p-4">
            {/* Current Position */}
            <div className="row mb-3">
                <div className="col-sm-4">
                    <p className="fw-bold mb-0">Current Position</p>
                </div>
                <div className="col-sm-8">
                    <p className="mb-0">
                        {user.profession}
                        {user.company && ` at ${user.company}`}
                    </p>
                </div>
            </div>

            {/* Experience Level */}
            <div className="row mb-3">
                <div className="col-sm-4">
                    <p className="fw-bold mb-0">Experience Level</p>
                </div>
                <div className="col-sm-8">
                    <p className="mb-0">{user.experience || 'Not specified'}</p>
                </div>
            </div>

            {/* Location */}
            <div className="row mb-3">
                <div className="col-sm-4">
                    <p className="fw-bold mb-0">Location</p>
                </div>
                <div className="col-sm-8">
                    <p className="mb-0">{locationName || 'Not specified'}</p>
                </div>
            </div>

            {/* Contact Email - Conditionally render this row */}
            {user.email && (
                <div className="row">
                    <div className="col-sm-4">
                        <p className="fw-bold mb-0">Contact Email</p>
                    </div>
                    <div className="col-sm-8">
                        <p className="mb-0">
                            {user.email} 
                        </p>
                    </div>
                </div>
            )}
        </div>
    </div>
  );
};

export default ProfessionalDetails; 